import style from './Edu.module.css';
import js from '../images/jslogo.svg';
import java from '../images/javalogo.svg';
import python from '../images/python.svg';
import git from '../images/github.svg';
import vue from '../images/vue.svg';
import sql from '../images/SQL.png';
import ts from '../images/ts.png';
import react from '../images/React.webp';
import node from '../images/node.svg';
import firebase from '../images/firebase.svg';
import c from '../images/c-1.svg'
import cplus from '../images/cplus.svg'
import { useEffect, useRef } from 'react';

export default function Edu({EduC}) {
    const sectionRef = useRef(null)
    const skillsGridRef = useRef(null)
    const options = {
        root: null,
        threshold: 0.2,
        rootMargin: "0px"
    }
    const callbackFunction = (entries) => {
        const[entry] = entries
        if (entry.isIntersecting) {
          document.getElementsByClassName(style.border)[0].classList.add(style.slidein)
        }
      }

    useEffect (() => {
        const section = sectionRef.current
        if (!section) return;
        const theObserver = new IntersectionObserver(callbackFunction, options)
        theObserver.observe(section);
        return () => {
            theObserver.unobserve(section);
        }
    },[]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (skillsGridRef.current) {
                skillsGridRef.current.scrollLeft = 0;
            }
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    return (
    <>
        <div ref={sectionRef}>
            <div ref={EduC} className={`banner_col ${style.border}`}>
                <div className={`decor`}>
                    <hr></hr>
                    <h1>SKILLS</h1>
                    <hr></hr>
                </div>
                <div className={style.carouselWrapper}>
                    <div ref={skillsGridRef} className={style.skillsGrid}>
                    <div className={`${style.categoryCard} card`}>
                        <div className={`${style.accentBar} card-accent-bar accent-purple`}></div>
                        <div className={style.cardContent}>
                            <h3 className={`${style.categoryTitle} card-title-purple`}>Languages</h3>
                            <div className={`${style.grid} skills`} >
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Python</p>
                        </div>
                        <div>
                            {/* <img src={sql}></img> */}
                            <p>SQL</p>
                        </div>
                        <div>
                            {/* <img src={ts}></img> */}
                            <p>TypeScript</p>
                        </div>
                        <div>
                            {/* <img src={js}></img> */}
                            <p>JavaScript</p>
                        </div>
                        <div>
                            {/* <img src={java}></img> */}
                            <p>Java</p>
                        </div>
                        <div>
                            {/* <img src={c}></img> */}
                            <p>C</p>
                        </div>
                        <div>
                            {/* <img src={cplus}></img> */}
                            <p>C++</p>
                        </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${style.categoryCard} card`}>
                        <div className={`${style.accentBar} card-accent-bar accent-pink`}></div>
                        <div className={style.cardContent}>
                            <h3 className={`${style.categoryTitle} card-title-pink`}>ML/AI Frameworks</h3>
                            <div className={`${style.grid} skills`} >
                        <div>
                            {/* <img src={python}></img> */}
                            <p>PyTorch</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>TensorFlow</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>scikit-learn</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>NumPy</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Pandas</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>LangChain</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Transformers</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>spaCy</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>SciPy</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Matplotlib</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Seaborn</p>
                        </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${style.categoryCard} card`}>
                        <div className={`${style.accentBar} card-accent-bar accent-blue`}></div>
                        <div className={style.cardContent}>
                            <h3 className={`${style.categoryTitle} card-title-blue`}>Data Infrastructure</h3>
                            <div className={`${style.grid} skills`} >
                        <div>
                            {/* <img src={python}></img> */}
                            <p>BigQuery</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>PostgreSQL</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>MongoDB</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Supabase</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Prisma</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Kafka</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Hugging Face</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Qdrant</p>
                        </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${style.categoryCard} card`}>
                        <div className={`${style.accentBar} card-accent-bar accent-orange`}></div>
                        <div className={style.cardContent}>
                            <h3 className={`${style.categoryTitle} card-title-orange`}>Web Development</h3>
                            <div className={`${style.grid} skills`} >
                        <div>
                            {/* <img src={react}></img> */}
                            <p>Next.js</p>
                        </div>
                        <div>
                            {/* <img src={react}></img> */}
                            <p>React</p>
                        </div>
                        <div>
                            {/* <img src={node}></img> */}
                            <p>Node.js</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>FastAPI</p>
                        </div>
                        <div>
                            {/* <img src={node}></img> */}
                            <p>Express.js</p>
                        </div>
                        <div>
                            {/* <img src={react}></img> */}
                            <p>Redux</p>
                        </div>
                        <div>
                            {/* <img src={node}></img> */}
                            <p>Axios</p>
                        </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${style.categoryCard} card`}>
                        <div className={`${style.accentBar} card-accent-bar accent-green`}></div>
                        <div className={style.cardContent}>
                            <h3 className={`${style.categoryTitle} card-title-green`}>Developer Tools</h3>
                            <div className={`${style.grid} skills`} >
                        <div>
                            {/* <img src={git}></img> */}
                            <p>Git</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Selenium</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Postman</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>REST APIs</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Charles Proxy</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Docker</p>
                        </div>
                        <div>
                            {/* <img src={python}></img> */}
                            <p>Jenkins</p>
                        </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}